// extracted by mini-css-extract-plugin
export default {"inner":"MainLayout-module--inner--2EkvQ"};